import { ProfileRedirect } from "@/components/ProfileRedirect";

const MiguelProfile = () => {
  return <ProfileRedirect username="miguel-escobedo" />;
};

export default MiguelProfile;
